import Nullstack from 'nullstack';
export default function IconSwitch({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-switch",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("polyline", {
    points: "15 4 19 4 19 8"
  }), "   ", Nullstack.element("line", {
    x1: "14.75",
    y1: "9.25",
    x2: "19",
    y2: "4"
  }), "   ", Nullstack.element("line", {
    x1: "5",
    y1: "19",
    x2: "9",
    y2: "15"
  }), "   ", Nullstack.element("polyline", {
    points: "15 19 19 19 19 15"
  }), "   ", Nullstack.element("line", {
    x1: "5",
    y1: "5",
    x2: "19",
    y2: "19"
  }), " ");
}